import { Template } from '@zeus/shared';
import { useNormalizedPixels } from '../../../../../hooks/useResize';
import { getScaleSize } from '../../../../../utils/utils';
import { memo, useMemo } from 'react';

interface Header {
  template: Omit<Template, 'content'>;
  scale?: number;
}

const Logo = ({ template, scale = 1 }: Header) => {
  const { normalizePixels } = useNormalizedPixels();

  const brandLogo = useMemo(
    () => (template?.brandLogo?.isEnabled ? template?.brandLogo?.image : null),
    [template.brandLogo]
  );

  if (!brandLogo) return null;

  return (
    <img
      src={template?.brandLogo?.image as string}
      alt="Brand logo"
      style={{ objectFit: 'contain', height: getScaleSize(normalizePixels(88, 'height'), scale) }}
    />
  );
};

export default memo(Logo);
